import { Actions, ActionTypes } from './actions';
import { initialState, VaultState } from './state';

export function VaultReducer(state = initialState, action: Actions): VaultState {
  switch (action.type) {
    case ActionTypes.USER_FOLDERS_SHARED_WITH_ME_REQUEST:
      return {
        ...state,
        userId: action.userId,
        // loader: action.loader,
      };
    case ActionTypes.USER_FOLDERS_SHARED_WITH_ME_COMPLETE:
      return {
        ...state,
        sharedWithMeFolder: action.payload,
        // loader: false,
      };

    case ActionTypes.USER_FOLDERS_SHARED_BY_ME_REQUEST:
      return {
        ...state,
        userId: action.userId,
        // loader: action.loader,
      };
    case ActionTypes.USER_FOLDERS_SHARED_BY_ME_COMPLETE:
      return {
        ...state,
        // sharedByMe: action.payload,
        // loader: false,
      };
    case ActionTypes.PERSONAL_FOLDER_FILES_REQUEST_RESET:
      return {
        ...state,
        is_personal_files_loading: true,
        personalFiles: [],
      };
    case ActionTypes.USER_FOLDERS_REQUEST:
      return {
        ...state,
        userId: action.userId,
        // loader: action.loader,
      };

    case ActionTypes.REMOVE_DEFAULT_FOLDER_REQUEST:
      return {
        ...state,
        requestModel: action.payload,
      };

    case ActionTypes.ADD_DEFAULT_FOLDER_REQUEST:
      return {
        ...state,
        requestModel: action.payload,
      };

    case ActionTypes.USER_FOLDER_FILES_REQUEST:
      return {
        ...state,
        requestModel: action.payload,
      };

    case ActionTypes.PERSONAL_FOLDER_FILES_COMPLETE:
      return {
        ...state,
        personalFiles: action.payload,
        is_personal_files_loading: false,
      };

    case ActionTypes.MOVE_FILE_TO_FOLDER_REQUEST:
      return {
        ...state,
        requestModel: action.payload,
      };

    case ActionTypes.SHARED_DATA_WITH_ME_REQUEST:
      return {
        ...state,
        requestModel: action.payload,
      };

    case ActionTypes.SHARED_DATA_WITH_ME_COMPLETE:
      return {
        ...state,
        sharedDataWithMe: action.payload,
      };

    case ActionTypes.SHARED_DATA_BY_ME_REQUEST:
      return {
        ...state,
        requestModel: action.payload,
      };

    case ActionTypes.SHARED_DATA_BY_ME_COMPLETE:
      return {
        ...state,
        sharedDataByMe: action.payload,
      };

    case ActionTypes.DELETE_FILE_COMPLETE:
      return {
        ...state,
        personalFiles: action.payload,
      };

    case ActionTypes.DELETE_FILE_REQUEST:
      return {
        ...state,
        requestModel: action.payload,
      };

    case ActionTypes.DELETE_FOLDER_REQUEST:
      return {
        ...state,
        requestModel: action.payload,
      };

    case ActionTypes.ADMIN_ACCESS_REQUEST:
      return {
        ...state,
      };

    case ActionTypes.ADMIN_ACCESS_COMPLETE:
      return {
        ...state,
        adminAccess: action.payload,
      };

    case ActionTypes.SHARED_FILES_IN_FOLDERS_WITH_ME_REQUEST:
      return {
        ...state,
        requestModel: action.payload,
      };

    case ActionTypes.SHARED_FILES_IN_FOLDERS_WITH_ME_COMPLETE:
      return {
        ...state,
        sharedFilesInFolders: action.payload.files,
        sharedSubfolders: action.payload.subFolders,
      };

    case ActionTypes.FORMS_REQUEST:
      return {
        ...state,
      };

    case ActionTypes.FORMS_COMPLETE:
      return {
        ...state,
        forms: action.payload,
      };
    case ActionTypes.DEFAULT_FOLDER_REQUEST:
      return {
        ...state,
        requestModel: action.payload,
      };

    case ActionTypes.CATEGORIES_REQUEST:
      return {
        ...state,
      };

    case ActionTypes.CATEGORIES_COMPLETE:
      return {
        ...state,
        categories: action.payload,
      };

    case ActionTypes.VAULT_STATS_REQUEST:
      return {
        ...state,
      };

    case ActionTypes.VAULT_STATS_COMPLETE:
      return {
        ...state,
        vaultState: action.payload,
      };

    case ActionTypes.OFFICE_STATS_REQUEST:
      return {
        ...state,
        loader: action.loader,
      };

    case ActionTypes.OFFICE_STATS_COMPLETE:
      return {
        ...state,
        vaults: action.payload,
        loader: false,
      };
    case ActionTypes.PERSONAL_FOLDER_FILES_REQUEST:
      return {
        ...state,
        is_personal_files_loading: action?.payload?.is_personal_files_loading ?? true,
        personalFiles: action?.payload?.is_personal_files_loading ? [] : state.personalFiles,
      };
    case ActionTypes.PERSONAL_FOLDER_FILES_REQUEST_CLEAR:
      return {
        ...state,
        personalFiles: [],
      };
    case ActionTypes.GET_VAULT_REQUEST:
      return {
        ...state,
        loader: action.loader,
      };
    case ActionTypes.GET_VAULT_SUCCESS:
      return {
        ...state,
        vaults: action.payload,
        loader: false,
      };
    case ActionTypes.SET_VAULT_SUCCESS:
      return {
        ...state,
        vaultId: action.vaultId,
        vaultName: action.vaultName,
      };
    default: {
      return state;
    }
  }
}
